import { render } from "./Modal4.vue?vue&type=template&id=0b80d576"
import script from "./Modal4.vue?vue&type=script&lang=js"
export * from "./Modal4.vue?vue&type=script&lang=js"

import "./Modal4.vue?vue&type=style&index=0&id=0b80d576&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__